import React, { Component } from 'react';

export default class SectionTwo extends Component {
    render() {
        return <section class="home-3 section cta-2">
        <div class="container">
            <div class="cta-box">
                <div class="row align-items-center">
                    <div class="col-lg-6">
                        <div class="cta-content">
                            <h1 class="text-white">Cosmos NFT NOTs honoring IBC Chains <span><b>Cosmos NOTs</b> NFTs that Give Back</span> </h1>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="cta-image">
                            <img src="images/not.png" alt="" class="img-fluid"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>;
    }
}
